import React from 'react';

const Sociology = () => {
  return (
    <div>
      Sociology
      Sociology
    </div>
  );
}

export default Sociology;
